module.exports = __webpack_public_path__ + "img/diploma2.3fcec2c8.jpg";